export default "__VITE_ASSET__3b098537__"